export default __webpack_public_path__ + "static/1870_1880-96894a522d10e6f9bba59dbda90dda2a.jpg";